<template>
  <div class="app-poster" v-loading="dataLoading">
    <div style="margin-bottom: 15px;">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="openDialog()">Add Poster</el-button>
    </div>

    <!-- 列表 -->
    <el-table :data="tableData" row-key="id">
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="name" label="Name" min-width="120" />
      <el-table-column prop="linkUrl" label="Link URL" min-width="150" show-overflow-tooltip />
      <el-table-column label="Images" min-width="180">
        <template slot-scope="scope">
          <div style="display: flex; gap: 10px;">
            <div v-if="scope.row.storages && scope.row.storages.zh" style="text-align: center;">
              <el-tag size="mini" type="info">ZH</el-tag>
              <br/>
              <el-image
                style="width: 50px; height: auto; margin-top: 5px;"
                :src="scope.row.storages.zh.url"
                :preview-src-list="[scope.row.storages.zh.url]"
              />
            </div>
            <div v-if="scope.row.storages && scope.row.storages.en" style="text-align: center;">
              <el-tag size="mini" type="info">EN</el-tag>
              <br/>
              <el-image
                style="width: 50px; height: auto; margin-top: 5px;"
                :src="scope.row.storages.en.url"
                :preview-src-list="[scope.row.storages.en.url]"
              />
            </div>
            <div v-if="scope.row.storages && scope.row.storages.ko" style="text-align: center;">
              <el-tag size="mini" type="info">KO</el-tag>
              <br/>
              <el-image
                style="width: 50px; height: auto; margin-top: 5px;"
                :src="scope.row.storages.ko.url"
                :preview-src-list="[scope.row.storages.ko.url]"
              />
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Start At" min-width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.startAt">{{ scope.row.startAt | displayTime() }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="End At" min-width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.endAt">{{ scope.row.endAt | displayTime() }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="sortOrder" label="Sort" width="65" align="center" />
      <el-table-column label="Active" width="70" align="center">
        <template slot-scope="scope">
          <div class="status-dot" :class="scope.row.isActive ? 'success' : 'danger'" />
        </template>
      </el-table-column>
      <el-table-column label="Updated At" min-width="175">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span style="margin-left: 8px">{{ scope.row.updatedAt | displayTime() }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Action" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" icon="el-icon-edit" size="small" @click="openDialog(scope.row)" />
          <el-button type="text" icon="el-icon-delete" size="small" style="color: #f56c6c;" @click="handleDelete(scope.row)" />
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑/创建对话框 -->
    <el-dialog class="poster-dialog" :title="form.id ? 'Edit Poster' : 'Add Poster'" :visible.sync="dialogVisible" width="540px" @close="resetForm">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px" size="small">
        <el-form-item label="Name" prop="name">
          <el-input v-model="form.name" />
        </el-form-item>

        <el-form-item label="Link URL" prop="linkUrl">
          <el-input v-model="form.linkUrl" placeholder="e.g. internal://... or https://..." />
        </el-form-item>

        <el-form-item label="Image (ZH)">
          <el-upload
            class="avatar-uploader"
            action=""
            :auto-upload="false"
            :show-file-list="false"
            :on-change="(file) => handleImageChange(file, 'zh')"
            accept="image/*"
            list-type="picture-card"
          >
            <img v-if="form.imagePreviewZh" :src="form.imagePreviewZh" class="avatar" />
            <img v-else-if="form.storages && form.storages.zh" :src="form.storages.zh.url" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        
        <el-form-item label="Image (EN)">
          <el-upload
            class="avatar-uploader"
            action=""
            :auto-upload="false"
            :show-file-list="false"
            :on-change="(file) => handleImageChange(file, 'en')"
            accept="image/*"
            list-type="picture-card"
          >
            <img v-if="form.imagePreviewEn" :src="form.imagePreviewEn" class="avatar" />
            <img v-else-if="form.storages && form.storages.en" :src="form.storages.en.url" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="Image (KO)">
          <el-upload
            class="avatar-uploader"
            action=""
            :auto-upload="false"
            :show-file-list="false"
            :on-change="(file) => handleImageChange(file, 'ko')"
            accept="image/*"
            list-type="picture-card"
          >
            <img v-if="form.imagePreviewKo" :src="form.imagePreviewKo" class="avatar" />
            <img v-else-if="form.storages && form.storages.ko" :src="form.storages.ko.url" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="Start At" prop="startAt">
          <el-date-picker
            v-model="form.startAt"
            type="datetime"
            value-format="timestamp"
            clearable
            style="width: 100%"
          />
        </el-form-item>

        <el-form-item label="End At" prop="endAt">
          <el-date-picker
            v-model="form.endAt"
            type="datetime"
            value-format="timestamp"
            clearable
            style="width: 100%"
          />
        </el-form-item>

        <el-form-item label="Sort Order" prop="sortOrder">
          <el-input-number v-model="form.sortOrder" :min="0" :step="1" />
        </el-form-item>

        <el-form-item label="Active" prop="isActive">
          <el-switch v-model="form.isActive" />
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button size="small" @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="submitForm">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  fetchAppPosters,
  upsertAppPoster,
  deleteAppPoster,
} from "@/api/admin";

export default {
  name: "AppPoster",
  data() {
    return {
      tableData: [],
      dataLoading: false,
      saving: false,
      dialogVisible: false,
      form: this.defaultForm(),
      rules: {
        name: [
          { required: true, message: "Name is required", trigger: "blur" },
        ],
        sortOrder: [
          { required: true, message: "Sort Order is required", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    defaultForm() {
      return {
        id: 0,
        name: "",
        linkUrl: "",
        startAt: null,
        endAt: null,
        isActive: true,
        sortOrder: 1,
        storages: null,
        imageFileZh: null,
        imageFileEn: null,
        imageFileKo: null,
        imagePreviewZh: "",
        imagePreviewEn: "",
        imagePreviewKo: "",
      };
    },
    fetchData() {
      this.dataLoading = true;
      fetchAppPosters()
        .then((response) => {
          if (response.success) {
            this.tableData = response.result.items || [];
          }
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    openDialog(row) {
      if (row) {
        this.form = {
          id: row.id,
          name: row.name,
          linkUrl: row.linkUrl || "",
          startAt: row.startAt || null,
          endAt: row.endAt || null,
          isActive: row.isActive,
          sortOrder: row.sortOrder,
          storages: row.storages || null,
          imageFileZh: null,
          imageFileEn: null,
          imageFileKo: null,
          imagePreviewZh: "",
          imagePreviewEn: "",
          imagePreviewKo: "",
        };
      } else {
        this.form = this.defaultForm();
      }
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    resetForm() {
      this.$refs.form && this.$refs.form.resetFields();
      this.form = this.defaultForm();
    },
    handleImageChange(file, lang) {
      if (lang === 'zh') {
        this.form.imageFileZh = file.raw;
        this.form.imagePreviewZh = URL.createObjectURL(file.raw);
      } else if (lang === 'en') {
        this.form.imageFileEn = file.raw;
        this.form.imagePreviewEn = URL.createObjectURL(file.raw);
      } else if (lang === 'ko') {
        this.form.imageFileKo = file.raw;
        this.form.imagePreviewKo = URL.createObjectURL(file.raw);
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;

        if (!this.form.id && !this.form.imageFileZh && !this.form.imageFileEn && !this.form.imageFileKo) {
          this.$message.error("At least one language image is required when creating a poster.");
          return;
        }

        if (this.form.startAt && this.form.endAt && this.form.startAt > this.form.endAt) {
          this.$message.error("Start time cannot be later than end time.");
          return;
        }

        this.saving = true;

        const formData = new FormData();
        if (this.form.id) {
          formData.append("id", this.form.id);
        } else {
          formData.append("id", "");
        }
        
        formData.append("name", this.form.name);
        
        if (this.form.linkUrl) {
          formData.append("linkUrl", this.form.linkUrl);
        } else {
          formData.append("linkUrl", "");
        }
        
        if (this.form.startAt) {
          formData.append("startAt", this.form.startAt);
        } else {
          formData.append("startAt", "");
        }
        
        if (this.form.endAt) {
          formData.append("endAt", this.form.endAt);
        } else {
          formData.append("endAt", "");
        }
        
        formData.append("isActive", this.form.isActive);
        formData.append("sortOrder", this.form.sortOrder);
        
        if (this.form.imageFileZh) {
          formData.append("imageZh", this.form.imageFileZh);
        }
        if (this.form.imageFileEn) {
          formData.append("imageEn", this.form.imageFileEn);
        }
        if (this.form.imageFileKo) {
          formData.append("imageKo", this.form.imageFileKo);
        }

        upsertAppPoster(formData)
          .then((response) => {
            if (response.success) {
              this.$notify({
                title: "Save successful",
                type: "success",
              });
              this.dialogVisible = false;
              this.fetchData();
            }
          })
          .finally(() => {
            this.saving = false;
          });
      });
    },
    handleDelete(row) {
      this.$confirm("Are you sure you want to delete this poster?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.dataLoading = true;
          deleteAppPoster(row.id)
            .then((response) => {
              if (response.success) {
                this.$notify({
                  title: "Delete successful",
                  type: "success",
                });
                this.fetchData();
              }
            })
            .finally(() => {
              this.dataLoading = false;
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.app-poster {
  ::v-deep .el-upload--picture-card {
    width: 124px;
    height: 124px;
    line-height: 128px;
  }

  ::v-deep .el-upload-list--picture-card .el-upload-list__item {
    width: 124px;
    height: 124px;
    line-height: 128px;
  }

  .poster-dialog .el-form {
    margin-top: 10px;
    margin-bottom: -10px;
    width: 90%;
  }
  
  .avatar {
    width: 122px;
    height: 122px;
    object-fit: contain;
  }

  .status-dot {
    width: 10px;
    height: 10px;
    border-radius: 5px;
    display: inline-block;

    &.success {
      background-color: #67c23a;
    }

    &.danger {
      background-color: #f56c6c;
    }
  }
}
</style>
